<template>
    <template v-if="isVisible">
        <button v-if="!hidden" @click="openRequestForm" class="td-btn primary td-text-uppercase icon-left">
            <icon name="faScrewdriverWrench" type="solid"></icon>
            <strong>Request Service</strong>
        </button>

        <transition name="modal">
            <modal v-if="showRequestForm" @close="closeRequestForm" class="edit-modal" hide-footer>
                <request-service-form 
                    :listing="listing"
                    :work="work"
                    :equipment="equipment"
                    @close="closeRequestForm"></request-service-form>
            </modal>
        </transition>
    </template>
</template>

<script>
import script from './RequestServiceButton';
    export default script;</script>

<style lang="less">
    @import './RequestServiceButton.less';
</style>